import { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box, CardHeader, IconButton, styled } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  "&:last-child": {
    padding: "5px",
  },
}));

export const DealBox = (props) => {
  const { children } = props;
  return (
    <Card sx={{ maxWidth: "600px", border: "0.5px solid" }}>
      <StyledCardContent>{children}</StyledCardContent>
    </Card>
  );
};
